import { Typography, styled } from "@mui/material"

export const RoleIdText = styled(Typography)({
  display: "block",
  color: "#6F7070",
  fontSize: "12px",
})
